import { QueryClient } from '@tanstack/react-query';

// Debounce map to track pending refetches
const debounceTimers = new Map<string, NodeJS.Timeout>();

/**
 * Debounced refetch for React Query
 * Prevents rapid successive refetches to the same query
 *
 * @param queryClient - TanStack Query client
 * @param queryKey - Query key to refetch
 * @param debounceMs - Debounce delay in milliseconds (default: 300ms)
 */
export const debouncedRefetch = (
  queryClient: QueryClient,
  queryKey: readonly unknown[],
  debounceMs: number = 300,
) => {
  const keyString = JSON.stringify(queryKey);

  // Clear existing timer for this query
  const existingTimer = debounceTimers.get(keyString);
  if (existingTimer) {
    clearTimeout(existingTimer);
  }

  // Set new timer
  const timer = setTimeout(() => {
    queryClient.refetchQueries({ queryKey });
    debounceTimers.delete(keyString);
  }, debounceMs);

  debounceTimers.set(keyString, timer);
};
